import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { useLenis } from "lenis/react";
import { ArrowDownRight } from "lucide-react";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/0380b2b5-443d-422e-9008-bfe58ac5771e/images/3436acfb3b31d728a371de5804169f9f4b1a245bd8cbc76105c90164f7a1c92e.jpeg";

const lines = ["Domina", "il tuo percorso.", "Offline."];

const lineVariant = {
  hidden: { y: "110%" },
  visible: (i) => ({
    y: "0%",
    transition: { duration: 1, delay: 0.4 + i * 0.15, ease: [0.16, 1, 0.3, 1] },
  }),
};

export default function Hero() {
  const ref = useRef(null);
  const lenis = useLenis();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.15]);
  const y = useTransform(scrollYProgress, [0, 1], [0, 180]);
  const overlayOpacity = useTransform(scrollYProgress, [0, 1], [0.45, 0.75]);

  return (
    <section ref={ref} className="relative min-h-screen overflow-hidden" data-testid="hero">
      <motion.div style={{ scale, y }} className="absolute inset-0 z-0">
        <img src={HERO_BG} alt="Moto enduro in azione al tramonto tra le montagne" className="w-full h-[115%] object-cover" />
      </motion.div>
      <motion.div style={{ opacity: overlayOpacity }} className="absolute inset-0 z-10 bg-[#1A2F24]" />
      <div className="absolute inset-0 z-10 bg-gradient-to-t from-black/60 via-transparent to-black/30" />

      <div className="relative z-20 min-h-screen max-w-[1600px] mx-auto px-6 md:px-12 flex flex-col justify-end pb-16 md:pb-24">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2, duration: 1 }}
          className="text-white/85 font-serif-editorial italic text-lg md:text-2xl mb-6 max-w-4xl"
        >
          Corso online gratuito con Ugo Filosa della <span className="whitespace-nowrap">Offroad Italia</span> — impara a usare OsmAnd in enduro e 4x4.
        </motion.p>

        <h1 className="font-display font-black text-white text-5xl sm:text-7xl md:text-[8.5vw] leading-[0.85] tracking-tighter">
          {lines.map((line, i) => (
            <span key={i} className="block overflow-hidden">
              <motion.span custom={i} variants={lineVariant} initial="hidden" animate="visible" className="block">
                {line}
              </motion.span>
            </span>
          ))}
        </h1>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.5, duration: 0.8 }}
          className="mt-10 flex flex-col sm:flex-row sm:items-center gap-6"
        >
          <button
            onClick={() => lenis && lenis.scrollTo("#iscrizione", { offset: -20 })}
            className="group inline-flex items-center gap-3 bg-primary text-primary-foreground rounded-full pl-7 pr-3 py-3 text-xs uppercase tracking-[0.25em] font-semibold hover:bg-primary/90 transition-colors w-fit"
            data-testid="hero-cta"
          >
            Prenota il tuo posto
            <span className="grid place-items-center w-9 h-9 rounded-full bg-white/20 group-hover:rotate-45 transition-transform duration-300">
              <ArrowDownRight className="w-4 h-4" />
            </span>
          </button>
          <span className="text-white/60 text-xs uppercase tracking-[0.2em]">100% Gratuito · Posti limitati · Iscrizioni entro il 20 agosto</span>
        </motion.div>
      </div>
    </section>
  );
}
